export default __webpack_public_path__ + "static/media/place.3158ce7d.svg";